import { render, staticRenderFns } from "./Ocorrencias.vue?vue&type=template&id=1a8400cf"
import script from "./Ocorrencias.vue?vue&type=script&lang=js"
export * from "./Ocorrencias.vue?vue&type=script&lang=js"
import style0 from "./Ocorrencias.vue?vue&type=style&index=0&id=1a8400cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports